import { BODY_TEXT, BORDER, GREY } from '../../../ThemeContext/constants';
import { theme } from '../../../ThemeContext/ThemeObject';
import { styles as sharedClasses } from '../styles';

export const styles = {
  ...sharedClasses,
  quotedCard: {
    padding: 2,
    borderRadius: '6px',
    border: `1px solid ${BORDER}`,
    rowGap: 0.5
  },
  quotedHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  quotedLabel: {
    color: GREY,
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase'
  },
  quotedSubject: {
    color: BODY_TEXT,
    fontSize: '14px',
    fontWeight: 600
  },
  quotedMeta: {
    color: GREY,
    fontSize: '12px'
  },
  quotedToggle: {
    flexDirection: 'row',
    alignItems: 'center',
    color: GREY,
    width: 'fit-content',
    cursor: 'pointer',
    fontSize: '12px',
    border: 'none',
    background: 'none',
    padding: 0,
    fontFamily: 'inherit'
  },
  quotedBody: {
    color: BODY_TEXT,
    fontSize: '14px',
    maxHeight: '150px',
    overflowY: 'auto',
    paddingTop: 1
  },
  modalInfoStyle: {
    color: GREY,
    fontFamily: 'Source Sans Pro',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: 'normal'
  },
  modalStyleOverrides: {
    height: 'auto',
    maxHeight: '84vh',
    width: '700px',
    maxWidth: 'calc(100vw - 32px)',
    boxSizing: 'border-box',
    padding: '40px'
  },
  // Figma 43152:27512 — the assign-attachment-title modal is a fixed 438px tall, with the
  // footer sitting at the bottom rather than directly under the single field.
  attachmentTitleModalOverrides: {
    height: '438px',
    maxHeight: '84vh',
    width: '700px',
    maxWidth: 'calc(100vw - 32px)',
    boxSizing: 'border-box',
    padding: '40px'
  },
  modalContainer: {
    width: '100%',
    height: '100%',
    rowGap: 3,
    overflow: 'auto'
  },
  errorMessage: {
    marginLeft: 0.5,
    color: '#E37D7A',
    fontSize: '12px'
  },
  autoCompleteTextfield: {
    '& .MuiInputBase-root': { margin: 'unset', marginTop: 1 },
    '& .MuiFormHelperText-root': {
      margin: 0.5,
      fontSize: '12px',
      fontFamily: 'inherit',
      color: theme.palette.error.main
    }
  },
  loaderContainer: {
    flexGrow: 1,
    rowGap: 3,
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.action.main,
    fontSize: '18px'
  },
  wideModal: { height: '90vh', width: '90vw', maxHeight: 'unset', maxWidth: 'unset' },
  subWidget: {
    marginTop: '24px',
    flex: '40%',
    borderRadius: '3px',
    height: '100px',
    minWidth: '240px'
  },
  widgetBlockContainer: {
    display: 'flex',
    height: '100%',
    width: '100%',
    columnGap: '50px'
  },
  widgetBlock: {
    border: `1px solid ${BORDER}`,
    borderRadius: '3px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingX: '16px',
    alignItems: 'center',
    width: '50%',
    height: '100%'
  },
  widgetBlockText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginLeft: '12px'
  },
  widgetBlockHeading: {
    color: theme.palette.primary.main
  },
  widgetBlockBody: {
    fontSize: '14px',
    color: BODY_TEXT
  },
  widgetBlockIcon: {
    backgroundColor: '#EDF2F5',
    padding: '12px',
    borderRadius: '8px',
    color: theme.palette.primary.main
  }
};
